export default "__VITE_ASSET__DXJ_bEJK__"